import { gql } from "@apollo/client";

export const GET_USER_QUERY = gql`
  query getCurrentUser {
    getCurrentUser {
      id
      name
      companyId
      hourlyWage
      role
      isAdmin
    }
  }
`;

export const GET_EMPLOYEE_BY_ID_QUERY = gql`
  query GetUserById($id: String!) {
    getUserById(id: $id) {
      id
      name
      email
      companyId
      role
    }
  }
`;
